const EVENTS_TYPES = 4
function getEventFilter(percent) {
  switch (percent) {
    case 1:
      return 'positive'
    case 2:
      return 'negative'
    case 3:
      return 'neutral'
    case 4:
      return 'decision'
    default:
      return 'neutral'
  }
}
export function getExecutableEvent(events) {
  const filteredEvents = getFilteredEvents(events)
  const percent = Math.floor(Math.random() * filteredEvents.length)

  return filteredEvents.find((event, index) => percent == index)
}

function getFilteredEvents(events) {
  const percent = Math.floor(Math.random() * EVENTS_TYPES) + 1
  const filter = getEventFilter(percent)
  return events.filter((event) => filter == event.type)
}
